import { render, staticRenderFns } from "./AssignProviderDropdown.vue?vue&type=template&id=395b8bc0&scoped=true&lang=pug&"
import script from "./AssignProviderDropdown.vue?vue&type=script&lang=js&"
export * from "./AssignProviderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AssignProviderDropdown.vue?vue&type=style&index=0&id=395b8bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b8bc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VProgressCircular,VSpacer,VTextField})
